import types from './types';

const INITIAL_STATE = {
    date: null,
    dateRange: {
        startDate: null,
        endDate: null,
        showDateRange: false
    },
    renderType: '',
    user: {},
    portfolios: [],
    chosenPortfolio: {},
    tradingChart: {},
    tradingReport: {},
    signalTableModalOpen: false,
    disableUploadButton: true,
    statusInfo: {},
    organizationUsers: [],
    organizationDocuments: [],
    passwordExpirationError: false
}

const GlobalReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.CHANGE_DATE:
            return {
                ...state,
                date: action?.payload
            }

        case types.CHANGE_DATE_RANGE:
            return {
                ...state,
                dateRange: { ...state?.dateRange, ...action?.payload }
            }

        case types.CHANGE_RENDER_TYPE:
            return {
                ...state,
                renderType: action?.payload
            }

        case types.CHANGE_USER_INFO:
            return {
                ...state,
                user: { ...state?.user, ...action?.payload }
            }

        case types.CHANGE_PORTFOLIOS_DATA:
            return {
                ...state,
                portfolios: action?.payload
            }

        case types.CHANGE_CHOSEN_PORTFOLIO_DATA:
            return {
                ...state,
                chosenPortfolio: action?.payload
            }

        case types.CHANGE_TRADING_CHART_DATA:
            return {
                ...state,
                tradingChart: action?.payload
            }

        case types.CHANGE_TRADING_REPORT_DATA:
            return {
                ...state,
                tradingReport: action?.payload
            }

        case types.TOGGLE_SIGNAL_TABLE_DIALOG:
            return {
                ...state,
                signalTableModalOpen: action?.payload
            }

        case types.FORCE_UPLOAD_DISABLE_BUTTON:
            return {
                ...state,
                disableUploadButton: action?.payload
            }

        case types.CHANGE_STATUS_INFO:
            return {
                ...state,
                statusInfo: action?.payload
            }

        case types.CHANGE_ORGANIZATION_USERS:
            return {
                ...state,
                organizationUsers: action?.payload
            }

        case types.CHANGE_ORGANIZATION_DOCUMENTS:
            return {
                ...state,
                organizationDocuments: action?.payload
            }
        case types.TOGGLE_EXPIRATION_ERROR:
            return {
                ...state,
                passwordExpirationError: action?.payload
            }

        default:
            return state;
    }
}

export default GlobalReducer;